<div class="page page-duvidas-frequentes" itemtype="https://schema.org/AboutPage">
      <div *ngIf="response.status == 1" itemprop="mainContentOfPage" itemscope itemtype="https://schema.org/WebPageElement">
        <div class="page-title" *ngIf="page.mostrar_titulo">
          <div class="container text-center">
            <h1 itemprop="name" class="page-title-h1">{{page.titulo}}</h1>
            <h2 *ngIf="page.mostrar_subtitulo" class="page-title-h2">{{page.subtitulo}}</h2>
          </div>  
        </div>  
        <div class="page-content">
          <section class="section descricao" *ngIf="page.mostrar_texto">
            <div class="container">
              <article itemprop="text" [innerHTML]="page.texto | safeHtml"></article>
            </div>  
          </section> 
          <section class="section section-duvidas">
            <div class="container">
              <div class="content" *ngIf="duvidas.length == 0">
                <p class="message-default">
                  Não temos nenhuma pergunta para te mostrar.
                </p>  
              </div>  
              <div class="content">
                <div class="item" *ngFor="let d of duvidas">
                  <duvida-item [data]="d"></duvida-item>
                </div>  
              </div>
            </div>  
          </section>   
        </div>
        <modulo posicao="whatsapp" template="fixo"></modulo> 
      </div> 
      <div *ngIf="response.status == 500"> 
        <div class="container"> 
          <page-error [data]="response.data" (reload)="getData()"></page-error>
        </div>  
      </div>  
</div>  
<loader message="Carregando Conteúdo" [hidden]="!loader"></loader>
        